// extracted by mini-css-extract-plugin
module.exports = {"anima":"RelicAvailability_anima__-tWXc","newSelection":"RelicAvailability_newSelection__27v7m"};